export type RecentGuestAccessEntry = {
  occasionSlug: string;
  occasionDisplayName: string;
  guestDisplayName: string;
  resumePath: string | null;
  localeCode?: string;
  timezone?: string | null;
  seenAt: string;
};

export const recentGuestAccessStorageKey = 'tov-plus.guests.recentAccess';

function isRecentGuestAccessEntry(
  value: unknown,
): value is RecentGuestAccessEntry {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false;
  }

  const candidate = value as Partial<RecentGuestAccessEntry>;

  return (
    typeof candidate.occasionSlug === 'string' &&
    typeof candidate.occasionDisplayName === 'string' &&
    typeof candidate.guestDisplayName === 'string' &&
    (candidate.resumePath === null ||
      typeof candidate.resumePath === 'string') &&
    (candidate.localeCode === undefined ||
      typeof candidate.localeCode === 'string') &&
    (candidate.timezone === undefined ||
      candidate.timezone === null ||
      typeof candidate.timezone === 'string') &&
    typeof candidate.seenAt === 'string'
  );
}

export function normalizeRecentGuestAccessEntries(
  value: unknown,
): RecentGuestAccessEntry[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(isRecentGuestAccessEntry);
}

export function parseRecentGuestAccessEntries(
  value: string | null,
): RecentGuestAccessEntry[] {
  if (!value) {
    return [];
  }

  try {
    return normalizeRecentGuestAccessEntries(JSON.parse(value));
  } catch {
    return [];
  }
}
